import React from 'react';

export default function Footer() {
  return (
    <div className="my-3 flex flex-col items-center  text-center">
      <span className="mx-3 text-sm text-gray-500 sm:text-center dark:text-gray-400">
        Made with 💙 by Muhammad Azar Nuzy © 2022
      </span>
    </div>
  );
}
